import { TLink } from "../../../types/link-types";
import { PrimaryButtonLink } from "../button/button";
import Heading from "../heading/heading";
import styles from "./job-opening-cta.module.less";
import { useTranslation } from "react-i18next";

export type TJobOpeningCtaProps = {
  heading?: string;
  jobTitle?: string;
  location?: string;
  employmentType?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  link?: TLink;
};

export const JobOpeningCta = ({
  heading,
  jobTitle,
  location,
  employmentType,
  contactEmail,
  contactName,
  contactPhone,
  link,
}: TJobOpeningCtaProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Heading visualType={"h5"} semanticType={"h3"} className={[styles.heading].join(" ")}>
        {heading ? heading : t("JOB_CTA_HEADING")}
      </Heading>
      {jobTitle && (
        <div className={styles.section}>
          <p className={[styles.title, "eyebrow"].join(" ")}>{t("JOB_TITLE")}</p>
          <p className={[styles.text, "body-base"].join(" ")}>{jobTitle}</p>
        </div>
      )}

      {location && (
        <div className={styles.section}>
          <p className={[styles.title, "eyebrow"].join(" ")}>{t("JOB_LOCATION")}</p>
          <p className={[styles.text, "body-base"].join(" ")}>{location}</p>
        </div>
      )}

      {employmentType && (
        <div className={styles.section}>
          <p className={[styles.title, "eyebrow"].join(" ")}>{t("JOB_EMPLOYMENT_TYPE")}</p>
          <p className={[styles.text, "body-base"].join(" ")}>{employmentType}</p>
        </div>
      )}

      {(contactPhone || contactEmail || contactName) && (
        <div className={styles.section}>
          <p className={[styles.title, "eyebrow"].join(" ")}>{t("JOB_CONTACT")}</p>
          {contactName && <p className={[styles.text, "body-base"].join(" ")}>{contactName}</p>}
          {contactPhone && <p className={[styles.text, "body-base"].join(" ")}>{contactPhone}</p>}
          {contactEmail && (
            <a href={`mailto:${contactEmail}`} className={[styles.email, "body-base"].join(" ")}>
              {contactEmail}
            </a>
          )}
        </div>
      )}

      {link?.url && (
        <div className={styles.buttonWrapper}>
          <PrimaryButtonLink
            url={link?.url}
            iconRight={link?.icon ?? "ui-icon-arrow-right"}
            label={t("JOB_APPLY_HERE")}
          />
        </div>
      )}
    </div>
  );
};

export default JobOpeningCta;
